<template>
  <el-autocomplete
    ref="autocomplete"
    v-model="innerValue"
    :fetch-suggestions="fetchSuggestions"
    :trigger-on-focus="true"
    :placeholder="placeholder"
    :debounce="200"
    :disabled="disabled"
    :style="inputStyle"
    clearable
    @select="onSelect"
    @blur="onBlur"
    @focus="onFocus"
    @keyup.enter.native="onEnter"
  >
    <template slot-scope="{ item }">
      <div class="stock-suggestion-item">
        <span class="stock-code">{{ item.displayCode || item.code6 || item.value }}</span>
        <span class="stock-name">{{ item.name }}</span>
        <span v-if="item.industry" class="stock-industry">{{ item.industry }}</span>
      </div>
    </template>
  </el-autocomplete>
</template>

<script>
import axios from 'axios'

const API_BASE = process.env.VUE_APP_API_URL || '/api'

// 本地热门股票回退列表（80+ 只股票）
const FALLBACK_STOCKS = [
  { ts_code: '600519.SH', name: '贵州茅台', code6: '600519', industry: '白酒' },
  { ts_code: '000858.SZ', name: '五粮液', code6: '000858', industry: '白酒' },
  { ts_code: '300750.SZ', name: '宁德时代', code6: '300750', industry: '新能源' },
  { ts_code: '002594.SZ', name: '比亚迪', code6: '002594', industry: '汽车' },
  { ts_code: '688981.SH', name: '中芯国际', code6: '688981', industry: '半导体' },
  { ts_code: '300059.SZ', name: '东方财富', code6: '300059', industry: '证券' },
  { ts_code: '000063.SZ', name: '中兴通讯', code6: '000063', industry: '通信' },
  { ts_code: '002230.SZ', name: '科大讯飞', code6: '002230', industry: 'AI' },
  { ts_code: '600036.SH', name: '招商银行', code6: '600036', industry: '银行' },
  { ts_code: '600030.SH', name: '中信证券', code6: '600030', industry: '证券' },
  { ts_code: '002050.SZ', name: '三花智控', code6: '002050', industry: '汽车零部件' },
  { ts_code: '600900.SH', name: '长江电力', code6: '600900', industry: '电力' },
  { ts_code: '688347.SH', name: '华虹公司', code6: '688347', industry: '半导体' },
  { ts_code: '601318.SH', name: '中国平安', code6: '601318', industry: '保险' },
  { ts_code: '600887.SH', name: '伊利股份', code6: '600887', industry: '食品' },
  { ts_code: '000651.SZ', name: '格力电器', code6: '000651', industry: '家电' },
  { ts_code: '600276.SH', name: '恒瑞医药', code6: '600276', industry: '医药' },
  { ts_code: '300760.SZ', name: '迈瑞医疗', code6: '300760', industry: '医疗器械' },
  { ts_code: '002415.SZ', name: '海康威视', code6: '002415', industry: '安防' },
  { ts_code: '601398.SH', name: '工商银行', code6: '601398', industry: '银行' },
  { ts_code: '601088.SH', name: '中国神华', code6: '601088', industry: '煤炭' },
  { ts_code: '601857.SH', name: '中国石油', code6: '601857', industry: '石油' },
  { ts_code: '600028.SH', name: '中国石化', code6: '600028', industry: '石油' },
  { ts_code: '600809.SH', name: '山西汾酒', code6: '600809', industry: '白酒' },
  { ts_code: '000568.SZ', name: '泸州老窖', code6: '000568', industry: '白酒' },
  { ts_code: '300308.SZ', name: '中际旭创', code6: '300308', industry: '光通信' },
  { ts_code: '002475.SZ', name: '立讯精密', code6: '002475', industry: '电子' },
  { ts_code: '002129.SZ', name: 'TCL中环', code6: '002129', industry: '光伏' },
  { ts_code: '300274.SZ', name: '阳光电源', code6: '300274', industry: '光伏' },
  { ts_code: '600438.SH', name: '通威股份', code6: '600438', industry: '光伏' },
  { ts_code: '002460.SZ', name: '赣锋锂业', code6: '002460', industry: '锂电' },
  { ts_code: '002466.SZ', name: '天齐锂业', code6: '002466', industry: '锂电' },
  { ts_code: '300014.SZ', name: '亿纬锂能', code6: '300014', industry: '电池' },
  { ts_code: '300124.SZ', name: '汇川技术', code6: '300124', industry: '工控' },
  { ts_code: '601899.SH', name: '紫金矿业', code6: '601899', industry: '矿业' },
  { ts_code: '600309.SH', name: '万华化学', code6: '600309', industry: '化工' },
  { ts_code: '600585.SH', name: '海螺水泥', code6: '600585', industry: '建材' },
  { ts_code: '601012.SH', name: '隆基绿能', code6: '601012', industry: '光伏' },
  { ts_code: '002714.SZ', name: '牧原股份', code6: '002714', industry: '养殖' },
  { ts_code: '300498.SZ', name: '温氏股份', code6: '300498', industry: '养殖' },
  { ts_code: '600031.SH', name: '三一重工', code6: '600031', industry: '机械' },
  { ts_code: '000002.SZ', name: '万科A', code6: '000002', industry: '地产' },
  { ts_code: '600048.SH', name: '保利发展', code6: '600048', industry: '地产' },
  { ts_code: '002049.SZ', name: '紫光国微', code6: '002049', industry: '芯片' },
  { ts_code: '603986.SH', name: '兆易创新', code6: '603986', industry: '芯片' },
  { ts_code: '002371.SZ', name: '北方华创', code6: '002371', industry: '半导体设备' },
  { ts_code: '688041.SH', name: '海光信息', code6: '688041', industry: '芯片' },
  { ts_code: '688256.SH', name: '寒武纪', code6: '688256', industry: 'AI芯片' },
  { ts_code: '300418.SZ', name: '昆仑万维', code6: '300418', industry: 'AI' },
  { ts_code: '600150.SH', name: '中国船舶', code6: '600150', industry: '船舶' },
  { ts_code: '601166.SH', name: '兴业银行', code6: '601166', industry: '银行' },
  { ts_code: '300033.SZ', name: '同花顺', code6: '300033', industry: '金融科技' },
  { ts_code: '688111.SH', name: '金山办公', code6: '688111', industry: '软件' },
  { ts_code: '000625.SZ', name: '长安汽车', code6: '000625', industry: '汽车' },
  { ts_code: '600050.SH', name: '中国联通', code6: '600050', industry: '通信' },
  { ts_code: '601728.SH', name: '中国电信', code6: '601728', industry: '通信' },
  { ts_code: '600893.SH', name: '航发动力', code6: '600893', industry: '军工' },
  { ts_code: '300122.SZ', name: '智飞生物', code6: '300122', industry: '医药' },
  { ts_code: '300015.SZ', name: '爱尔眼科', code6: '300015', industry: '医疗' },
  { ts_code: '601628.SH', name: '中国人寿', code6: '601628', industry: '保险' },
  { ts_code: '600570.SH', name: '恒生电子', code6: '600570', industry: '金融科技' },
  { ts_code: '300394.SZ', name: '天孚通信', code6: '300394', industry: '光通信' },
  { ts_code: '688012.SH', name: '中微公司', code6: '688012', industry: '半导体设备' },
  { ts_code: '688008.SH', name: '澜起科技', code6: '688008', industry: '芯片' },
  { ts_code: '603501.SH', name: '韦尔股份', code6: '603501', industry: '芯片' },
  { ts_code: '600760.SH', name: '中航沈飞', code6: '600760', industry: '军工' },
  { ts_code: '000538.SZ', name: '云南白药', code6: '000538', industry: '医药' },
  { ts_code: '688599.SH', name: '天合光能', code6: '688599', industry: '光伏' },
  { ts_code: '300782.SZ', name: '卓胜微', code6: '300782', industry: '芯片' },
  { ts_code: '002304.SZ', name: '洋河股份', code6: '002304', industry: '白酒' },
  { ts_code: '600690.SH', name: '海尔智家', code6: '600690', industry: '家电' },
  { ts_code: '600104.SH', name: '上汽集团', code6: '600104', industry: '汽车' },
  { ts_code: '601615.SH', name: '明阳智能', code6: '601615', industry: '风电' },
  { ts_code: '601988.SH', name: '中国银行', code6: '601988', industry: '银行' },
  { ts_code: '601288.SH', name: '农业银行', code6: '601288', industry: '银行' },
  { ts_code: '601939.SH', name: '建设银行', code6: '601939', industry: '银行' },
  { ts_code: '600941.SH', name: '中国移动', code6: '600941', industry: '通信' },
  { ts_code: '001979.SZ', name: '招商蛇口', code6: '001979', industry: '地产' },
  { ts_code: '603993.SH', name: '洛阳钼业', code6: '603993', industry: '矿业' },
  { ts_code: '002025.SZ', name: '航天电器', code6: '002025', industry: '军工' },
  { ts_code: '002007.SZ', name: '华兰生物', code6: '002007', industry: '医药' },
  { ts_code: '600391.SH', name: '航发科技', code6: '600391', industry: '军工' },
  { ts_code: '510050.SH', name: '上证50ETF', code6: '510050', industry: 'ETF' },
  { ts_code: '510300.SH', name: '沪深300ETF', code6: '510300', industry: 'ETF' },
  { ts_code: '510500.SH', name: '中证500ETF', code6: '510500', industry: 'ETF' },
  { ts_code: '588000.SH', name: '科创50ETF', code6: '588000', industry: 'ETF' },
  { ts_code: '159915.SZ', name: '创业板ETF', code6: '159915', industry: 'ETF' },
]

export default {
  name: 'StockCodeInput',
  props: {
    value: { type: String, default: '' },
    placeholder: { type: String, default: '输入代码或名称，如: 600000 或 茅台（自动匹配，无需后缀）' },
    disabled: { type: Boolean, default: false },
    width: { type: String, default: '220px' }
  },
  data() {
    return {
      innerValue: this.value,
      lastSelectedCode: ''
    }
  },
  computed: {
    inputStyle() {
      return { width: this.width }
    }
  },
  watch: {
    value(val) {
      this.innerValue = val
    },
    innerValue(val) {
      this.$emit('input', val)
    }
  },
  methods: {
    /**
     * 根据6位数字代码自动补全交易所后缀
     */
    fillSuffix(code6) {
      if (!code6 || !/^\d{6}$/.test(code6)) return code6
      if (code6.startsWith('6') || code6.startsWith('5')) {
        return code6 + '.SH'
      } else if (code6.startsWith('0') || code6.startsWith('3') || code6.startsWith('1')) {
        return code6 + '.SZ'
      } else if (code6.startsWith('4') || code6.startsWith('8')) {
        return code6 + '.BJ'
      }
      return code6 + '.SH'
    },

    async fetchSuggestions(query, callback) {
      const q = (query || '').trim()

      // 空查询时展示热门股票（聚焦时）
      if (!q || q.length < 1) {
        const popular = FALLBACK_STOCKS.slice(0, 20)
        callback(popular.map(s => ({
          value: s.code6,
          displayCode: s.code6,
          label: `${s.code6} - ${s.name}`,
          ts_code: s.ts_code,
          name: s.name,
          code6: s.code6,
          industry: s.industry || ''
        })))
        return
      }

      const qUpper = q.toUpperCase()
      try {
        const res = await axios.get(`${API_BASE}/stock/suggestions`, {
          params: { q, limit: 20 }
        })
        let data = (res.data && res.data.data) || []

        // 如果后端返回空数据，使用本地回退列表
        if (data.length === 0) {
          data = this._fallbackSearch(q)
        }

        const suggestions = data.map(s => ({
          value: s.code6 || (s.ts_code ? s.ts_code.split('.')[0] : ''),
          displayCode: s.code6 || (s.ts_code ? s.ts_code.split('.')[0] : ''),
          label: `${s.code6 || s.ts_code} - ${s.name}`,
          ts_code: s.ts_code,
          name: s.name,
          code6: s.code6 || (s.ts_code ? s.ts_code.split('.')[0] : ''),
          industry: s.industry || ''
        }))
        callback(suggestions)
      } catch (e) {
        console.error('获取股票建议失败，使用本地回退:', e)
        const fallback = this._fallbackSearch(q)
        const suggestions = fallback.map(s => ({
          value: s.code6,
          displayCode: s.code6,
          label: `${s.code6} - ${s.name}`,
          ts_code: s.ts_code,
          name: s.name,
          code6: s.code6,
          industry: s.industry || ''
        }))
        callback(suggestions)
      }
    },

    /**
     * 本地回退搜索（支持代码和名称匹配）
     */
    _fallbackSearch(keyword) {
      const kw = keyword.toUpperCase()
      return FALLBACK_STOCKS.filter(s => {
        // 代码匹配：支持纯数字和带后缀的匹配
        const codeMatch = s.code6.includes(kw)
        // 名称匹配：支持中文和拼音首字母
        const nameMatch = s.name.includes(keyword) || s.name.toUpperCase().includes(kw)
        // 行业匹配
        const industryMatch = s.industry && s.industry.includes(keyword)
        return codeMatch || nameMatch || industryMatch
      }).slice(0, 20)
    },

    onSelect(item) {
      // 选择后自动填入完整的 ts_code（带后缀），但显示纯数字
      const fullCode = item.ts_code || this.fillSuffix(item.code6 || item.value)
      this.innerValue = item.code6 || item.value  // 显示纯数字
      this.lastSelectedCode = fullCode
      this.$emit('select', {
        ts_code: fullCode,
        code6: item.code6 || item.value,
        name: item.name,
        industry: item.industry
      })
      this.$emit('input', fullCode)  // 发出完整代码
      // 延迟恢复显示纯数字
      this.$nextTick(() => {
        this.innerValue = item.code6 || item.value
      })
    },

    onBlur() {
      // blur 时格式化：纯6位数字自动补后缀
      if (this.innerValue && this.innerValue.includes('.')) {
        // 已有后缀，保持不变
      } else if (this.innerValue && /^\d{6}$/.test(this.innerValue.trim())) {
        const fullCode = this.fillSuffix(this.innerValue.trim())
        this.innerValue = this.innerValue.trim()  // 保持纯数字显示
        this.$emit('blur', fullCode)
        return
      }
      this.$emit('blur', this.innerValue)
    },

    onFocus() {
      this.$emit('focus')
    },

    onEnter() {
      this.$emit('enter', this.innerValue)
    }
  }
}
</script>

<style scoped>
.stock-suggestion-item {
  display: flex;
  align-items: center;
  padding: 3px 0;
  width: 100%;
}
.stock-code {
  font-weight: 600;
  color: #409EFF;
  font-family: monospace;
  font-size: 14px;
  min-width: 70px;
}
.stock-name {
  margin-left: 12px;
  color: #303133;
  font-size: 14px;
  flex: 1;
}
.stock-industry {
  color: #909399;
  font-size: 12px;
  text-align: right;
  min-width: 60px;
}
</style>
